<template>
  <div class="alert alert-info alert-icon">
    <i class="fa fa-exclamation"></i>
    Please pay your deposit to continue with this booking.
    <router-link :to="{
      name: 'payments.show',
      params: {
        bookingId: booking.id,
        action: 'process',
        paymentId: bookingPaymentDeposit.id,
        props: { default: true, showMessage: false }
      } }">
      Go to payment
    </router-link>.
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import { mapState } from 'vuex'

export default {
  mixins: [helpers],

  computed: {
    ...mapState('booking', ['booking'])
  }
}
</script>
